import { useCallback, useRef, useState } from 'react';

const useDelayedAction = (timeout = 3000): [boolean, (action: () => void) => void, () => void, () => void] => {
    const [pending, setPending] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>();
    const cleanup = useCallback(() => {
        setPending(false);
        timeoutRef.current = null;
    }, []);
    const cancel = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            cleanup();
        }
    }, [cleanup]);
    const delay = useCallback(
        action => {
            setPending(true);
            timeoutRef.current = setTimeout(() => {
                action();
                // cleanup must be explicitly called
                // cleanup();
            }, timeout);
        },
        [timeout]
    );
    return [pending, delay, cancel, cleanup];
};

export default useDelayedAction;
